import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import App from "./App";
import AdminAccessConsole from "./AdminAccessConsole"; // <-- thêm import
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* FE tra cứu inventory */}
        <Route path="/" element={<App />} />

        {/* Bảng điều khiển Admin */}
        <Route path="/admin" element={<AdminAccessConsole />} />

        {/* Redirect/404 */}
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route
          path="*"
          element={
            <div style={{ padding: 24 }}>404 — Không tìm thấy trang</div>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
